import { render, staticRenderFns } from "./Valeu.vue?vue&type=template&id=4f38d3fe&scoped=true&"
import script from "./Valeu.vue?vue&type=script&lang=js&"
export * from "./Valeu.vue?vue&type=script&lang=js&"
import style0 from "./Valeu.vue?vue&type=style&index=0&id=4f38d3fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f38d3fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VContent,VFlex,VLayout})
